import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig.js";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming you have a similar function to log actions

async function modifyFolderPackBasic(folderid, packid, couples, token, prefix) {
  try {
    // Define the endpoint URL
    const url = prefix + `folders/${folderid}/convert-basic`;

    // Extract clientId from the Firestore document reference

    // Define the request body
    const body = {
      packid: packid ? packid : "vide",
      couples: couples,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    // Make the PUT request
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Get the current user reference using Firebase Authentication
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    // Get the Firestore reference for the current user
    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document (assuming you have an `addLogDocument` function)
    await addLogDocument(
      url,
      prefix,
      userRef, // Pass only the user ID
      org_id, // Organization reference from Firestore
      response.status.toString(),
      folderid,
      "",
      JSON.stringify(body),
      await response.text(), // Get the response body as text
      "PUT"
    );

    // Check if the request was successful
    if (response.ok) {
      return "Folder modified successfully";
    } else {
      console.error(`Failed to modify folder: ${response.status}`);
      return `Failed to modify folder: ${response.status}`;
    }
  } catch (error) {
    console.error("Exception occurred while modifying folder:", error);
    return `Exception occurred: ${error.message}`;
  }
}

export default modifyFolderPackBasic;
